<template>
    <LoadingCard v-if="loading" />
    <div v-else>
        <div class="toolbar">
            <div class="toolbar__label">
                Types of crops being grown
            </div>
        </div>

        <div class="card">
            <div class="card-header bg-primary text-white">
                Crop Types
            </div>
            <b-table small hover stacked="md" :items="allCropTypes" :fields="table.fields" sort-by="name" :show-empty="true"
                     @row-clicked="handleCropTypeToggle">

                <template slot="name" slot-scope="row">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input"
                               :id="`cropType${row.item.id}`" type="checkbox"
                               :disabled="cropTypeInUse(row.item)"
                               :checked="linkedCropTypes.includes(row.item.id)"
                        >
                        <label class="custom-control-label" :for="`cropType${row.item.id}`">{{ row.item.name }}</label>
                    </div>
                </template>

                <template slot="blocks" slot-scope="row">
                    <span v-if="!cropTypeInUse(row.item)" class="text-muted">(none)</span>
                    <span class="badge badge-light mr-1 mb-1" v-for="block in linkedBlocks(row.item)" v-else>
                        {{ block.name }}
                    </span>
                </template>

            </b-table>
        </div>

    </div>
</template>
<script>
import createGrowerCropTypeLinkMutation from '@views/Setup/CropTypeManager/mutationCreateGrowerCropTypeLink.graphql';
import deleteGrowerCropTypeLinkMutation from '@views/Setup/CropTypeManager/mutationDeleteGrowerCropTypeLink.graphql';
import listBlocksQuery from '@views/Setup/CropTypeManager/queryListBlocks.graphql';
import listCropTypesQuery from '@views/Setup/CropTypeManager/queryListCropTypes.graphql';
import listGrowerLinkedCropTypesQuery from '@views/Setup/CropTypeManager/queryListGrowerLinkedCropTypes.graphql';

export default {
  name: 'CropTypeManager',

  apollo: {
    allCropTypes: {
      query: listCropTypesQuery,
      update: data => data.filterCropTypes.data,
    },
    linkedCropTypes: {
      query: listGrowerLinkedCropTypesQuery,
      update: data => data.filterGrowerCropTypeLinks.map(item => item.id),
    },
    blocks: {
      query: listBlocksQuery,
      update: data => data.filterBlocks.data,
    },
  },
  data() {
    return {
      allCropTypes: [],
      linkedCropTypes: [],
      blocks: [],
      loading: 0,
      table: {
        fields: [
          { key: 'name', label: 'Crop Type', sortable: true },
          { key: 'blocks', label: 'Blocks' },
        ],
      },
    };
  },
  methods: {
    cropTypeInUse(cropType) {
      return this.blocks.some(block => {
        return this.$path.get(block, 'cropType.id') === cropType.id;
      });
    },
    linkedBlocks(cropType) {
      return this.blocks.filter(block => {
        return this.$path.get(block, 'cropType.id') === cropType.id;
      });
    },
    handleCropTypeToggle(cropType) {
      if (this.cropTypeInUse(cropType)) {
        return false;
      } else if (this.linkedCropTypes.includes(cropType.id)) {
        this.unlinkCropType(cropType);
      } else {
        this.linkCropType(cropType);
      }
    },
    unlinkCropType(cropType) {
      this.$apollo.mutate({
        mutation: deleteGrowerCropTypeLinkMutation,
        variables: {
          input: {
            id: cropType.id,
          },
        },
        update: (
          store,
          { data: { deleteGrowerCropTypeLink: unlinkedCropType } },
        ) => {
          const data = store.readQuery({
            query: listGrowerLinkedCropTypesQuery,
          });
          const indexToRemove = data.filterGrowerCropTypeLinks.findIndex(
            item => item.id === unlinkedCropType.id,
          );
          if (indexToRemove !== -1) {
            data.filterGrowerCropTypeLinks.splice(indexToRemove, 1);
          }
          store.writeQuery({ query: listGrowerLinkedCropTypesQuery, data });
        },
        optimisticResponse: {
          __typename: 'Mutation',
          deleteGrowerCropTypeLink: {
            __typename: 'CropType',
            blocks_count: 0,
            ...cropType,
          },
        },
      });
    },
    linkCropType(cropType) {
      this.$apollo.mutate({
        mutation: createGrowerCropTypeLinkMutation,
        variables: {
          input: {
            id: cropType.id,
          },
        },
        update: (
          store,
          { data: { createGrowerCropTypeLink: linkedCropType } },
        ) => {
          const data = store.readQuery({
            query: listGrowerLinkedCropTypesQuery,
          });
          data.filterGrowerCropTypeLinks.push(linkedCropType);
          store.writeQuery({ query: listGrowerLinkedCropTypesQuery, data });
        },
        optimisticResponse: {
          __typename: 'Mutation',
          createGrowerCropTypeLink: {
            __typename: 'CropType',
            blocks_count: 0,
            ...cropType,
          },
        },
      });
    },
  },
};
</script>
